export default {
  computed: {
    sasAccreditation() {
      return this.sas.sasAccreditation
    },
    codeFormat() {
      if (this.sasAccreditation) {
        return this.getCatalogueCodeById(this.$constants.DESCID.ACCREDITATION.FORMAT, this.sasAccreditation.formatDeFormation)
      }

      return ""
    },
    estMidiScientifique() {
      return this.codeFormat === this.$constants.CODE.FORMAT.MIDI_SCIENTIFIQUE
    },
    estCongres() {
      return this.codeFormat === this.$constants.CODE.FORMAT.CONGRES
    },
    estCongresOuMidiScientifique() {
      return [this.$constants.CODE.FORMAT.CONGRES, this.$constants.CODE.FORMAT.MIDI_SCIENTIFIQUE].includes(this.codeFormat)
    },
    estAutoApprentissage() {
      return this.codeFormat === this.$constants.CODE.FORMAT.AUTOAPPRENTISSAGE
    },
    estRenouvellementOuNouveauFormat() {
      return [this.$constants.CODE.TYPE_DEMANDE.RENOUVELLEMENT, this.$constants.CODE.TYPE_DEMANDE.NOUVEAU_FORMAT].includes(
        this.getCatalogueCodeById(this.$constants.DESCID.ACCREDITATION.TYPE_DEMANDE, this.sasAccreditation.typeDeDemande)
      )
    }
  },
  methods: {
    liveSasAccreditation(cle) {
      return { endpoint: "sas-accreditations", cle: cle, fileId: this.sasAccreditation.id }
    }
  }
}